import { useState, useEffect } from "react";
import { Form, Input, Modal, Button, Select } from "antd";
import { useNavigate } from "react-router-dom";
import clanakService from "../../services/clanak.service";
import "./AddNewClanak.css";
import "../Anketa/AddNewAnketa.css";
import kategorijaClankaService from "../../services/kategorijaClanka.service";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { uploadImage } from "../../services/uploadImage.service";
import dayjs from "dayjs";
import { Upload } from "antd";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import Background4 from "../../components/Background4";
import { useAuth } from "../../components/AuthContext";

const AddNewClanak = () => {
  const [naslov, setNaslov] = useState("");
  const [sadrzaj, setSadrzaj] = useState("");
  const [autor, setAutor] = useState("");
  const [slika, setSlika] = useState("");
  const [kategorije, setKategorije] = useState([]);
  const [kategorija, setKategorija] = useState(1);
  const navigate = useNavigate();
  const [galerijaClanak, setGalerijaClanak] = useState([]);
  const [galerijaPreview, setGalerijaPreview] = useState([]);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { username } = useAuth();
  useEffect(() => {
    const fetchKategorije = async () => {
      try {
        const response = await kategorijaClankaService.getAll();
        setKategorije(response.data);
      } catch (error) {}
    };

    fetchKategorije();
  }, []);

  const handleGalerijaChange = (e) => {
    const files = Array.from(e.target.files);

    setGalerijaClanak((prev) => [...prev, ...files]);

    setGalerijaPreview((prev) => [
      ...prev,
      ...files.map((file) => URL.createObjectURL(file)),
    ]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);

    setGalerijaClanak((prev) => [...prev, ...files]);

    setGalerijaPreview((prev) => [
      ...prev,
      ...files.map((file) => URL.createObjectURL(file)),
    ]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  function resizeImage(file, maxWidth = 1024, maxHeight = 1024) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          if (width > maxWidth || height > maxHeight) {
            const aspectRatio = width / height;
            if (aspectRatio > 1) {
              width = maxWidth;
              height = maxWidth / aspectRatio;
            } else {
              height = maxHeight;
              width = maxHeight * aspectRatio;
            }
          }

          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error("Greška prilikom skaliranja slike"));
              return;
            }

            const resizedFile = new File([blob], file.name, {
              type: file.type,
            });
            resolve(resizedFile);
          }, file.type);
        };

        img.onerror = reject;
        img.src = e.target.result;
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  const isFormValid = () => {
    return naslov.trim() !== "" && sadrzaj.trim() !== "" && autor.trim() !== "";
  };

  const handleAddClanak = async () => {
    if (!isFormValid()) {
      setErrorMessage("Molimo vas da popunite polja prije slanja.");
      setIsErrorModalVisible(true);
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(sadrzaj, "text/html");
    const images = doc.querySelectorAll("img");
    for (let img of images) {
      const src = img.getAttribute("src");

      if (src.startsWith("data:")) {
        const blob = await (await fetch(src)).blob();
        const file = new File([blob], "uploaded_image.png", {
          type: blob.type,
        });

        try {
          const uploadedUrl = await uploadImage(file);
          img.setAttribute("src", uploadedUrl);
        } catch (error) {}
      }
    }

    const updatedHtml = doc.body.innerHTML;

    const formData = new FormData();
    formData.append("naslov", naslov);
    formData.append("autor", autor);
    formData.append("sadrzaj", updatedHtml);
   // formData.append("datumObjave", new Date().toISOString());
   formData.append("datumObjave", dayjs().format("YYYY-MM-DDTHH:mm:ss"));
    formData.append("kategorijaClankaId", kategorija);
    formData.append("korisnickoIme", username);
    if (slika) {
      const resized = await resizeImage(slika);
      formData.append("glavnaSlika", resized);
    }

    if (galerijaClanak && galerijaClanak.length > 0) {
      galerijaClanak.forEach((file) => {
        formData.append("galerijaClanak", file);
      });
    }
    try {
      await clanakService.uploadClanak(formData);
      alert("Članak uspješno sačuvan!");
      navigate(`/zaposleni/kategorijaClanka/${kategorija}`);
    } catch (error) {}
  };

  return (
    <div>
      <Background4 />
      <div className="clanak-card">
        <Form
          layout="horizontal"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 18 }}
          className="poll-form"
        >
          <Form.Item required wrapperCol={{ span: 24, offset: 0 }}>
            <Input
              value={naslov}
              onChange={(e) => setNaslov(e.target.value)}
              placeholder="Unesite naslov članka"
              className="naslov-clanka-add"
            />
          </Form.Item>

          <Form.Item label="Ime autora" required>
            <Input
              value={autor}
              onChange={(e) => setAutor(e.target.value)}
              placeholder="Autor"
              className="input-field add-new-anketa-input"
            />
          </Form.Item>

          <Form.Item label="Kategorija">
            <Select
              value={kategorija}
              onChange={setKategorija}
              className="select-field add-new-anketa-select"
            >
              {kategorije.map((kategorija) => (
                <Select.Option key={kategorija.id} value={kategorija.id}>
                  {kategorija.naziv}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Glavna slika">
            <Upload
              beforeUpload={(file) => {
                setSlika(file);
                return false;
              }}
              showUploadList={{ showPreviewIcon: false }}
              accept="image/*"
              maxCount={1}
            >
              <Button icon={<UploadOutlined />}>Izaberi glavnu sliku</Button>
            </Upload>
          </Form.Item>
          <Form.Item label="Sadržaj">
            <SunEditor
              setContents={sadrzaj}
              onChange={(content) => setSadrzaj(content)}
              setOptions={{
                height: "auto",
                buttonList: [
                  [
                    "undo",
                    "redo",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "align",
                    "fontSize",
                    "fontColor",
                    "hiliteColor",
                    "link",
                    "image",
                    "video",
                    "fullScreen",
                  ],
                ],
                imageUploadUrl: "",
                imageResizing: true,
                resizingBar: true,
              }}
              onImageUploadBefore={(files, info, uploadHandler) => {
                const file = files[0];
                const reader = new FileReader();
                reader.onload = function (e) {
                  uploadHandler({
                    result: [
                      {
                        url: e.target.result,
                        name: file.name,
                        size: file.size,
                      },
                    ],
                  });
                };
                reader.readAsDataURL(file);
                return false;
              }}
            />
          </Form.Item>

          <Form.Item label="Galerija slika">
            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              style={{
                border: "2px dashed #39ad90",
                padding: "16px",
                borderRadius: "8px",
                textAlign: "center",
                marginBottom: "10px",
                backgroundColor: "#f2faf8",
                cursor: "pointer",
              }}
              onClick={() =>
                document.getElementById("galerijaUploadInput").click()
              }
            >
              <label
                htmlFor="galerijaUploadInput"
                style={{ cursor: "pointer" }}
              >
                <PlusOutlined
                  style={{
                    fontSize: 30,
                    color: "#39ad90",
                    border: "1px dashed #39ad90",
                    padding: 10,
                    borderRadius: "8px",
                  }}
                />
              </label>

              <p className="ant-upload-text">
                Prevucite slike ovdje ili kliknite da izaberete
              </p>

              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleGalerijaChange}
                style={{ display: "none" }}
                id="galerijaUploadInput"
              />
            </div>

            {galerijaPreview.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginTop: "15px",
                  justifyContent: "flex-start",
                }}
              >
                {galerijaPreview.map((src, index) => (
                  <div key={index} style={{ position: "relative" }}>
                    <img
                      src={src}
                      alt={`preview-${index}`}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "6px",
                        border: "1px solid #a9d6c8",
                      }}
                    />
                    <Button
                      danger
                      size="small"
                      onClick={() => {
                        setGalerijaPreview((prev) =>
                          prev.filter((_, i) => i !== index)
                        );
                        setGalerijaClanak((prev) =>
                          prev.filter((_, i) => i !== index)
                        );
                      }}
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        padding: "0 6px",
                        fontSize: 12,
                        height: 20,
                      }}
                    >
                      X
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </Form.Item>
        </Form>

        <Modal
          title="Greška"
          visible={isErrorModalVisible}
          onOk={() => setIsErrorModalVisible(false)}
          onCancel={() => setIsErrorModalVisible(false)}
          okText="U redu"
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <p>{errorMessage}</p>
        </Modal>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            size="large"
            onClick={handleAddClanak}
            className="button-primary"
          >
            Sačuvaj članak
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddNewClanak;
